import WebsiteBehaviors from "../website-behaviors/index.js";

class AMLegal extends WebsiteBehaviors {
	identifier() {
		return "AMLegal";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "library.amlegal.com");
	}

	shouldFrameTakeControl() {
		return window.self.name === "docbody";
	}
}

export default AMLegal;
